import { Component, inject, signal } from '@angular/core';
import { ButtonModule } from '@fino-ui/button';
import { FinoCommonModule } from '@fino-ui/common';
import { FinoTranslationModule } from '@fino-ui/translation';
import { ClipboardService } from 'ngx-clipboard';
import { Toast } from 'ngx-toastr';
import { take } from 'rxjs';

/**
 * Toast component used for every error notification. Unlike the fino default it
 * wraps long messages instead of clipping them and offers a copy button, since
 * error messages are usually raw backend responses that get forwarded to us.
 */
@Component({
  selector: 'app-error-notification',
  templateUrl: './error-notification.component.html',
  styleUrls: ['./error-notification.component.sass'],
  imports: [ButtonModule, FinoCommonModule, FinoTranslationModule],
})
export class ErrorNotificationComponent extends Toast {
  private readonly clipboardService = inject(ClipboardService);

  public readonly copied = signal(false);

  copyMessage($event: MouseEvent) {
    // The toast dismisses itself on click (tapToDismiss), so the copy button
    // must not let the event bubble up to the host.
    $event.stopPropagation();

    // copy() reports its result on a shared stream and only emits while
    // something is listening, so subscribe before triggering it.
    this.clipboardService.copyResponse$
      .pipe(take(1))
      .subscribe(({ isSuccess }) => this.copied.set(isSuccess));

    this.clipboardService.copy(this.message());
  }
}
